import { Typo } from '@geberit/gdds';

// styles
import styles from './address-box.module.scss';

// types
import type { AdressBoxProps } from './address-box.types';

// components
import { Headline } from 'components/ContentElementsGdds/headline/headline';

// utils
import { useSelector } from 'react-redux';
import { translationKeysSelector } from 'utils/selectors/translationSelectors';
import { Formats } from 'components/ContentElementsGdds/headline/headlines.types';
import { useXy } from 'utils/hooks/use-xy';

function ListEntryWithLabel(props: Readonly<{ label?: string; value?: string }>) {
  return (
    <li className={styles.listEntryWithLabel}>
      <span className={styles.listEntryWithLabel__label}>{props.label}</span>
      <span>{props.value ?? '-'}</span>
    </li>
  );
}

export function AddressBox({
  title,
  address,
  salutation,
  country,
  isDelivery = false,
}: Readonly<AdressBoxProps>) {
  const translations = useSelector(translationKeysSelector);
  const isXy = useXy();

  const ListContent = (
    <>
      <li>
        {address.salutation && salutation} {address.firstName} {address.lastName}
      </li>
      {address.company && <li>{address.company}</li>}
      <li>
        {address.street} {address.street2}
      </li>
      <li>
        {address.zip} {address.city}
      </li>
      <li>
        {country}
      </li>
      {!isDelivery && (
        <>
          <ListEntryWithLabel
            label={translations?.web20_checkout_address_email_label}
            value={address.email}
          />
          <ListEntryWithLabel
            label={translations?.web20_checkout_address_phone_number_label}
            value={address.phone}
          />
          <ListEntryWithLabel
            label={translations?.web20_checkout_address_mobile_phone_number_label}
            value={address.mobile}
          />
        </>
      )}
      {!isDelivery && address.sapCustomerNumber && <li>ID {address.sapCustomerNumber}</li>}
    </>
  )

  return (
    <div className="addressBox">
      {isXy ? (
        <>
          <Headline
            isFlexItem
            tag={Formats.h4}
            variant={Formats.subtitle}
            className={`${styles.addressBoxHeadline} ${styles.bottomMargin}`}
            title={title}
          />
          <Typo tag='ul' className={`${styles.addressBoxWrapper} ${styles.bottomMargin}`}>
            {ListContent}
          </Typo>
        </>
      ):(
        <>
          <h4 className={styles.bottomMargin}>{title}</h4>
          <ul className={`${styles.addressBoxWrapper} ${styles.bottomMargin}`}>
            {ListContent}
          </ul>
        </>
      )}
    </div>
  );
}
